import React, { useState, useRef } from "react";
import emailjs from '@emailjs/browser';
import Navbar from "../../Components/Navbar/Navbar";
import Contacts from "../../Components/Contacts/Contacts";
import Footer from "../../Components/Footer/Footer";
import Props from "../../Components/prop/Props";
import "./Finalcontact.css";
import logo from "../../Assets/kl.png";
import ph3 from "../../Assets/7.jpg";

const FinalContact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    user_phone: "",
    user_location: "",
    user_products: "",
    user_quantity: "",
    message: ""
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Handle form submission
  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    // Replace these with your actual EmailJS credentials
    const SERVICE_ID = 'service_8bfus6h'; // e.g., 'service_8bfus6h'
    const TEMPLATE_ID = 'template_9s0wu5t'; // Create template in EmailJS
    const PUBLIC_KEY = 'EXx9dawdezy7nEmXb'; // From EmailJS account settings

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
        console.log('SUCCESS!', result.text);
        alert('Message sent successfully!');
        setLoading(false);
        // Reset form
        setFormData({
          user_name: "",
          user_email: "",
          user_phone: "",
          user_location: "",
          user_products: "",
          user_quantity: "",
          message: ""
        });
      }, (error) => {
        console.log('FAILED...', error.text);
        alert('Failed to send message. Please try again.');
        setLoading(false);
      });
  };

  return (
    <>
      <Navbar />
      <Props img={ph3} />

      <div className="message">
        <div className="message1">
          <h1>Let's Makes Business Together</h1>
          <p>
            Please don't hesitate to contact us if you have any questions,
            Comments or messages. we'll try to respond to everything.
          </p>
          <div className="mes1">
            <div className="mes1img">
              <img src={logo} alt="" />
            </div>
            <div className="mes1con">
              <h1>Enquiry for High Quality Safety Matches</h1>
              <form ref={form} onSubmit={sendEmail}>
                <div className="mes2">
                  <input 
                    type="text" 
                    name="user_name"
                    placeholder="NAME" 
                    value={formData.user_name}
                    onChange={handleChange}
                    required
                  />
                  <input 
                    type="email" 
                    name="user_email"
                    placeholder="EMAIL" 
                    value={formData.user_email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mes2">
                  <input 
                    type="tel" 
                    name="user_phone"
                    placeholder="PHONE" 
                    value={formData.user_phone}
                    onChange={handleChange}
                    required
                  />
                  <input 
                    type="text" 
                    name="user_location"
                    placeholder="LOCATION" 
                    value={formData.user_location}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mes2">
                  <input 
                    type="text" 
                    name="user_products"
                    placeholder="PRODUCTS" 
                    value={formData.user_products}
                    onChange={handleChange}
                    required
                  />
                  <input 
                    type="text" 
                    name="user_quantity"
                    placeholder="QUANTITY" 
                    value={formData.user_quantity}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mes3">
                  <textarea
                    name="message"
                    placeholder="Write your message here"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button type="submit" disabled={loading}>
                  {loading ? 'SENDING...' : 'SEND MESSAGE'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="map">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3939.125191994988!2d77.90174467449994!3d9.143164287192496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06adb6a3c50363%3A0xd1c3fcb94c63481!2sTHANGARAJ%20MATCH%20FACTORY!5e0!3m2!1sen!2sin!4v1755438065367!5m2!1sen!2sin"   
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <Contacts />
      <Footer />
    </>
  );
};

export default FinalContact;